const INITIAL_STATE = {
  representativeList: {},
  errors: {},
}
    
const representativeList = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'GET_REPRESENTATIVES_LIST':
    return { ...state, ...INITIAL_STATE, representativeList: action.data }
  case 'GET_REPRESENTATIVES_LIST_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};
    
export default representativeList;